export const adminListApiKeys = `query adminListApiKeys {
  adminListApiKeys{
    keyId
    label
    description
    active
    issuedAt
    expirationTime
    impersonatedUserId
    applications {
      applicationId
      execute
      deploy
    }
  }
}`;

export const adminGetApiKey = `query adminGetApiKey($keyId: ID!) {
  adminGetApiKey(keyId: $keyId){
    keyId
    label
    description
    impersonatedUserId
    active
    issuedAt
    expirationTime
    applications {
      applicationId
      execute
      deploy
    }
  }
}`;
